import { render, staticRenderFns } from "./feedB.vue?vue&type=template&id=403a1ec2&scoped=true"
import script from "./feedB.vue?vue&type=script&lang=js"
export * from "./feedB.vue?vue&type=script&lang=js"
import style0 from "./feedB.vue?vue&type=style&index=0&id=403a1ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403a1ec2",
  null
  
)

export default component.exports